module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8lEJo"))).then(() => module.bundle.root('ewmtE'));